import React, {useEffect, useState} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import Link from '@salesforce/retail-react-app/app/components/link'
import {useSiteContext} from '../../contexts/site'
import useTagManager from '../../hooks/use-tag-manager'

const AssistiveADA = () => {
    const {isYR} = useSiteContext()
    const {
        app: {commerceAPI}
    } = getConfig()
    const styles = useMultiStyleConfig('Header')
    const [isScriptLoaded, setIsScriptLoaded] = useState(false)
    const {siteTheme} = commerceAPI.storefront
    var themeJSON = {}
    try {
        themeJSON = JSON.parse(siteTheme)
    } catch (e) {
        console.log(e.message)
    }

    const tagManager = useTagManager()
    const {usablenet} = commerceAPI
    const {config} = usablenet || {}

    var enableAssistiveADA = false
    var usablenetTagUrl = null

    try {
        const jsonConfig = JSON.parse(config)
        enableAssistiveADA = jsonConfig.enabled
        usablenetTagUrl = jsonConfig.scriptURL
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (isScriptLoaded) {
            const baseDisableUsableNetAssistive = window.disableUsableNetAssistive

            window.disableUsableNetAssistive = function () {
                tagManager.headerInteraction('exit accessibility mode')
                return baseDisableUsableNetAssistive.call(this)
            }
        }
    }, [isScriptLoaded])

    useEffect(() => {
        if (enableAssistiveADA && usablenetTagUrl) {
            var adaLinkAdded = false
            var CONTROL_INTERVAL_MODULE = setInterval(function () {
                /** Not a reactJS practice - We need to make this element appear inside the top of the body  **/
                const assistiveElementWrapper = document.querySelector('.assistive-wrapper')
                if (assistiveElementWrapper) {
                    assistiveElementWrapper.parentNode.removeChild(assistiveElementWrapper)
                    document.body.insertBefore(assistiveElementWrapper, document.body.firstChild)

                    if (!adaLinkAdded) {
                        var adaLink = document.querySelector(
                            '.assistive-wrapper .enable-accessibility'
                        )

                        adaLink.addEventListener('click', (event) => {
                            var hasDisableADA = event.target.parentNode.querySelector(
                                '.disableUsableNetAssistive'
                            )
                            if (hasDisableADA) {
                                tagManager.headerInteraction('exit accessibility mode')
                            } else {
                                tagManager.headerInteraction('accessibility')
                            }
                        })
                        adaLinkAdded = true
                        setIsScriptLoaded(true)
                    }
                    clearInterval(CONTROL_INTERVAL_MODULE)
                }
            }, 500) // check for every 500ms

            const script = document.createElement('script')
            script.id = 'usntA42start'
            script.src = usablenetTagUrl
            script.type = 'text/javascript'
            script.setAttribute('data-rapid', 'true')
            script.async = true
            script.defer = true
            document.body.appendChild(script)

            return () => {
                document.body.removeChild(script)
            }
        }
    }, [enableAssistiveADA, usablenetTagUrl])
    return (
        <Box
            {...styles.accessibilityLinkWrapper}
            className="assistive-wrapper"
            sx={{
                '.disableUsableNetAssistive': {
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    color: {
                        xxxs: isYR
                            ? themeJSON?.['yr']?.accessibilityColor
                                ? `${themeJSON?.['yr']?.accessibilityColor} !important`
                                : 'white !important'
                            : themeJSON?.['ks']?.accessibilityColor
                            ? `${themeJSON?.['ks']?.accessibilityColor} !important`
                            : 'black',
                        base: 'teal.600 !important'
                    }
                },
                '.accessibility-placeholder': {
                    minWidth: '89px'
                }
            }}
            data-enable-accessibility={enableAssistiveADA}
        >
            <Box className="ada-spacer js-ada-spacer"></Box>
            <Box className="js-ada-placeholder hide-element js-body-tag"></Box>
            <Link
                href="#"
                _hover={{
                    textDecoration: {
                        lg: 'none'
                    }
                }}
                color={{
                    xxxs: isYR
                        ? themeJSON?.['yr']?.accessibilityColor || 'white'
                        : themeJSON?.['ks']?.accessibilityColor || 'black.100',
                    base: 'teal.600'
                }}
                className="enable-accessibility redirect-link utility-link UsableNetAssistive ada-redesign"
                onClick={() => {
                    window.enableUsableNetAssistive()
                }}
            >
                <FormattedMessage id="enable.accessibility" defaultMessage="Enable Accessibility" />
            </Link>
        </Box>
    )
}

export default AssistiveADA
